import { render } from "./buySubscribtion.vue?vue&type=template&id=8cb02e98&scoped=true"
import script from "./buySubscribtion.vue?vue&type=script&lang=js"
export * from "./buySubscribtion.vue?vue&type=script&lang=js"

import "./buySubscribtion.vue?vue&type=style&index=0&id=8cb02e98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb02e98"]])

export default __exports__